<template>
  <div class="common_bg explain" :class="{'posi':from==='home'}">
    <div class="law">
      <div class="title">
        <span>儿童隐私保护政策</span>
      </div>
      <div class="content">
        <iframe src="https://agreement.limiketang.com/children/limixinqihang_index.html" frameborder="0"></iframe>
      </div>
    </div>
    <Back @goBack="goBack"/>
  </div>
</template>

<script>
import Back from "@/components/basic/back.vue";
export default {
  name: "childrenPolicy",
  components: {
    Back
  },
  props:{
    from:{
      default:''
    }
  },
  methods: {
    goBack() {
      if(this.from==='home'){
        this.$router.replace({
          path: "/"
        });
        return
      }
      this.$router.push("/userinfo");
    }
  }
}
</script>

<style lang="less" scoped>
@bg-color: #0089ce;
.posi{
  position: absolute;
  z-index: 999;
  top: 0;
}
.contnet-common {
  width: 100%;
  height: 100%;
  padding-bottom: 60px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.explain {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
.title {
  width: 100%;
  height: 80px;
  line-height: 80px;
  background: @bg-color;
  font-size: 26px;
  color: #fff;
  position: relative;
  margin-bottom: 15px;
}
.law {
.contnet-common;
}
.law .content {
  background: #fff;
  height: 100%;
  margin: 0 auto;
  width:1024px;
  overflow: hidden;
  border-radius: 20px;
iframe {
  width: 100%;
  height: 100%;
}
}
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/explain/childrenPolicy.vue